import React from "react";
import { InputAttributes, NumberFormatBaseProps, NumericFormat } from "react-number-format";

import BaseInput from "../BaseInput";

interface NumberFormatInputProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const NumberFormatInput = React.forwardRef<NumberFormatBaseProps<InputAttributes>, NumberFormatInputProps>(
  function NumberFormatCustom(props, ref) {
    const { onChange, ...rest } = props;

    return (
      <NumericFormat
        {...rest}
        customInput={BaseInput}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator
        valueIsNumericString
        prefix="$"
      />
    );
  },
);

export default NumberFormatInput;
